import { BackendStatusData } from './GalenData/BackendStatus.model';
import { DeviceDataValue } from './GalenData/DeviceDataValue.model';
import { GlobalStatus, ModelStatus } from './GalenData/DeviceDataView.model';

const defaultModelStatus: DeviceDataValue<ModelStatus> = {
  value: ModelStatus.NA,
};

export const defaultBackendStatus: BackendStatusData = {
  GlobalStatus: { value: GlobalStatus.Null },
  SessionId: { value: '' },
  GeneralQualityStatus: defaultModelStatus,
};
